import { editPricingOfAccountEmailFinderCampaign, getPricingOfAccountEmailFinderCampaign } from "../types/account_campaign_pricing_email_finder_types";

export const getPricingOfAccountEmailFinderCampaignRequest = (payload, cb) => ({
  type: getPricingOfAccountEmailFinderCampaign.GET_PRICING_OF_ACCOUNT_EMAIL_FINDER_CAMPAIGN_REQUEST,
  payload,
  cb,
});
export const getPricingOfAccountEmailFinderCampaignSuccess = (payload) => ({
  type: getPricingOfAccountEmailFinderCampaign.GET_PRICING_OF_ACCOUNT_EMAIL_FINDER_CAMPAIGN_SUCCESS,
  payload,
});
export const getPricingOfAccountEmailFinderCampaignError = (payload) => ({
  type: getPricingOfAccountEmailFinderCampaign.GET_PRICING_OF_ACCOUNT_EMAIL_FINDER_CAMPAIGN_ERROR,
  payload,
});

export const editPricingOfAccountEmailFinderCampaignRequest = (payload, cb) => ({
  type: editPricingOfAccountEmailFinderCampaign.EDIT_PRICING_OF_ACCOUNT_EMAIL_FINDER_CAMPAIGN_REQUEST,
  payload,
  cb,
});
export const editPricingOfAccountEmailFinderCampaignSuccess = (payload) => ({
  type: editPricingOfAccountEmailFinderCampaign.EDIT_PRICING_OF_ACCOUNT_EMAIL_FINDER_CAMPAIGN_SUCCESS,
  payload,
});
export const editPricingOfAccountEmailFinderCampaignError = (payload) => ({
  type: editPricingOfAccountEmailFinderCampaign.EDIT_PRICING_OF_ACCOUNT_EMAIL_FINDER_CAMPAIGN_ERROR,
  payload,
});
